import { css, unsafeCSS } from "lit";
import { buttonOnDarkStyles } from "../button/button--onDark.styles";
import { sbkCoreBreakpointLg } from "@/tokens/variables";
const breakpointLg = unsafeCSS(`${sbkCoreBreakpointLg}`);

export const style = css`

  :host([alternativestyling]) {
    ${buttonOnDarkStyles}
  }

  :host {
      --button__border--focus: var(--_button__border--focus, var(--sbkButtonBorderOnLightFocus));

      --primary-button__bg: var(--_primary-button__bg, var(--sbkButtonBgColorPrimaryOnLightEnabled));
      --primary-button__color: var(--_primary-button__color, var(--sbkButtonFgColorOnDarkDefault));
      --primary-button__bg--hover: var(--_primary-button__bg--hover, var(--sbkButtonBgColorPrimaryOnLightHover));
      --primary-button__color--hover: var(--_primary-button__color--hover, var(--sbkButtonFgColorOnDarkDefault));
      --primary-button__bg--active: var(--_primary-button__bg--active, var(--sbkButtonBgColorPrimaryOnLightActive));
      --primary-button__color--active: var(--_primary-button__color--active, var(--sbkButtonFgColorOnDarkDefault));
      --primary-button__bg--focus: var(--_primary-button__bg--focus, var(--sbkButtonBgColorPrimaryOnLightFocus));
      --primary-button__color--focus: var(--_primary-button__color--focus, var(--sbkButtonFgColorOnDarkDefault));
      --primary-button__bg--disabled: var(--_primary-button__bg--disabled, var(--sbkButtonBgColorPrimaryOnLightDisabled));
      --primary-button__color--disabled: var(--_primary-button__color--disabled, var(--sbkButtonFgColorOnLightDisabled));

      --secondary-button__bg: var(--_secondary-button__bg, var(--sbkButtonBgColorSecondaryOnLightEnabled));
      --secondary-button__color: var(--_secondary-button__color, var(--sbkButtonFgColorOnLightDefault));
      --secondary-button__bg--hover: var(--_secondary-button__bg--hover, var(--sbkButtonBgColorSecondaryOnLightHover));
      --secondary-button__color--hover: var(--_secondary-button__color--hover, var(--sbkButtonSecondaryFgColorOnLightHover));
      --secondary-button__bg--active: var(--_secondary-button__bg--active, var(--sbkButtonBgColorSecondaryOnLightActive));
      --secondary-button__color--active: var(--_secondary-button__color--active, var(--sbkButtonFgColorOnDarkDefault));
      --secondary-button__bg--focus: var(--_secondary-button__bg--focus, var(--sbkButtonBgColorSecondaryOnLightFocus));
      --secondary-button__color--focus: var(--_secondary-button__color--focus, var(--sbkButtonFgColorOnDarkDefault));
      --secondary-button__bg--disabled: var(--_secondary-button__bg--disabled, var(--sbkButtonBgColorSecondaryOnLightDisabled));
      --secondary-button__color--disabled: var(--_secondary-button__color--disabled, var(--sbkButtonFgColorOnLightDisabled));
      --secondary-button__border-color: var(--_secondary-button__border-color, var(--sbkButtonBorderOnLightEnabled));
      --secondary-button__border-color--hover: var(--_secondary-button__border-color--hover, var(--sbkButtonBorderOnLightHover));
      --secondary-button__border-color--focus: var(--_secondary-button__border-color--focus, var(--sbkButtonBgColorSecondaryOnLightFocus));
      --secondary-button__border-color--active: var(--_secondary-button__border-color--active, var(--sbkButtonBorderOnLightActive));
      --secondary-button__border-color--disabled: var(--_secondary-button__border-color--disabled, var(--sbkButtonBorderOnLightDisabled));

      --cta-button__bg: var(--_cta-button__bg, var(--sbkButtonBgColorCtaOnLightEnabled));
      --cta-button__color: var(--_cta-button__color, var(--sbkButtonFgColorOnLightDefault));
      --cta-button__border: var(--_cta-button__border, var(--sbkButtonBorderOnLightDefault));
      --cta-button__bg--hover: var(--_cta-button__bg--hover, var(--sbkButtonBgColorCtaOnLightHover));
      --cta-button__color--hover: var(--_cta-button__color--hover, var(--sbkButtonFgColorOnLightDefault));
      --cta-button__bg--active: var(--_cta-button__bg--active, var (--sbkButtonBgColorCtaOnLightActive));
      --cta-button__color--active: var(--_cta-button__color--active, var(--sbkButtonFgColorOnLightDefault));
      --cta-button__bg--focus: var(--_cta-button__bg--focus, var(--sbkButtonBgColorCtaOnLightFocus));
      --cta-button__color--focus: var(--_cta-button__color--focus, var(--sbkButtonFgColorOnLightDefault));
      --cta-button__bg--disabled: var(--_cta-button__bg--disabled, var(--sbkButtonBgColorCtaOnLightDisabled));
      --cta-button__color--disabled: var(--_cta-button__color--disabled, var(--sbkButtonFgColorOnLightDisabled));

      display: inline-block;
  }

  a {
      width: fit-content;
  }

  .button {
      part: button;
      display: flex;
      gap: var(--sbkButton3xs);
      align-items: center;
      justify-content: center;
      outline: 2px solid transparent;
      outline-offset: var(--sbkButtonBorderGapFocus);
      border-radius: var(--sbkButtonBorderRadiusDefault);
      border: none;
      cursor: pointer;
      text-decoration: none;
      fill: currentColor;
  }

  .button:focus-visible {
      outline: var(--button__border--focus);
  }

  .button[disabled] {
      cursor: not-allowed;
  }

  .button-xsmall {
      font: var(--sbkButtonSmallLabelSm);
      padding: var(--sbkButton3xs) var(--sbkButtonMd);
  }

  .button-small {
      font: var(--sbkButtonSmallLabelSm);
      padding: var(--sbkButton2xs) var(--sbkButtonMd);
  }

  .button-large {
      font: var(--sbkButtonLargeLableMd);
      padding: var(--sbkButtonXs) var(--sbkButtonXl);
  }

  .button-adaptive{
    font: var(--sbkButtonSmallLabelSm);
    padding: var(--sbkButton2xs) var(--sbkButtonMd);
  }
    @media screen and (min-width: ${breakpointLg}) {
    .button-adaptive{
        font: var(--sbkButtonLargeLableMd);
        padding: var(--sbkButtonXs) var(--sbkButtonXl);
    }}

  .button-table {
    width: initial !important;
  }

  /* Primary Button Styles */

  .button-primary {
      background-color: var(--primary-button__bg);
      color: var(--primary-button__color);
      border: var(--secondary-button__border-color); 
      border-color: var(--primary-button__bg);
  }

    @media (hover: hover) and (pointer: fine) {
        .button-primary:not([disabled]):hover {
            background-color: var(--primary-button__bg--hover);
            color: var(--primary-button__color--hover);
            &:not(:focus-visible):not(:active){
                border-color: var(--primary-button__bg--hover);
            }

        }
    }

  .button-primary:active {
      background-color: var(--primary-button__bg--active);
      color: var(--primary-button__color--active);
       border-color: var(--primary-button__bg--active);
  }

  .button-primary:focus-visible {
      background-color: var(--primary-button__bg--focus);
      color: var(--primary-button__color--focus);
      border-color: var(--primary-button__bg--focus);
  }

  .button-primary[disabled] {
      background-color: var(--primary-button__bg--disabled);
      color: var(--primary-button__color--disabled);
      border-color: var(--primary-button__bg--disabled);
  }

  /* Secondary Button Styles */

  .button-secondary {
      background-color: var(--secondary-button__bg);
      border: var(--secondary-button__border-color);
      color: var(--secondary-button__color);
  }

    @media (hover: hover) and (pointer: fine) {
        .button-secondary:not([disabled]):hover {
            background-color: var(--secondary-button__bg--hover);
            border: var(--secondary-button__border-color--hover);
            color: var(--secondary-button__color--hover);
        }
    }

  .button-secondary:active {
      background-color: var(--secondary-button__bg--active);
      border: var(--secondary-button__border-color--active);
      color: var(--secondary-button__color--active);
  }

  .button-secondary:focus-visible {
      background-color: var(--secondary-button__bg--focus);
      border-color: var(--secondary-button__border-color--focus);
      color: var(--secondary-button__color--focus);
  }

  .button-secondary[disabled] {
      background-color: var(--secondary-button__bg--disabled);
      border: var(--secondary-button__border-color--disabled);
      color: var(--secondary-button__color--disabled);
  }

  /* CTA Button Styles */
  .button-cta {
      background-color: var(--cta-button__bg);
      border: var(--cta-button__border);
      color: var(--cta-button__color);
  }

    @media (hover: hover) and (pointer: fine) {
        .button-cta:not([disabled]):hover {
            background-color: var(--cta-button__bg--hover);
            color: var(--cta-button__color--hover);
        }
    }

  .button-cta:active {
      background-color: var(--cta-button__bg--active);
      color: var(--cta-button__color--active);
  }

  .button-cta:focus-visible {
      background-color: var(--cta-button__bg--focus);
      color: var(--cta-button__color--focus);
  }

  .button-cta[disabled] {
      background-color: var(--cta-button__bg--disabled);
      color: var(--cta-button__color--disabled);
      border-color: var(--cta-button__bg--disabled);
  }

  /* Meta CTA Button Styles */
  .button-meta-cta {
      background-color: var(--cta-button__bg);
      border-radius: var(--sbkButtonBorderRadiusMetaCta) var(--sbkButtonBorderRadiusMetaCta) 0 0;
      color: var(--cta-button__color);
  }

    @media (hover: hover) and (pointer: fine) {
        .button-meta-cta:hover {
            background-color: var(--cta-button__bg--hover);
            color: var(--cta-button__color--hover);
        }
    }

  .button-meta-cta:active {
      background-color: var(--cta-button__bg--active);
      color: var(--cta-button__color--active);
  }

  .button-meta-cta:focus-visible {
      background-color: var(--cta-button__bg--focus);
      color: var(--cta-button__color--focus);
  }

  .button-meta-cta[disabled] {
      background-color: var(--cta-button__bg--disabled);
      color: var(--cta-button__color--disabled);
  }
  
  .button-hidden {
    display: none;
  }
`;
